/**
 * Cliente HTTP del frontend hacia /api.
 * Una sola fuente de verdad para URLs y errores.
 */

import type {
  ClientData,
  MouilletteScores,
  Preferences,
  Recommendation,
  SkinMeasures,
} from '@/types';

const BASE = (import.meta.env.VITE_API_BASE as string | undefined) ?? '/api';

export interface PostConsultationPayload {
  id: string;
  storeId: string;
  sellerId?: string;
  client: ClientData;
  skin: SkinMeasures;
  preferences: Preferences;
  mouillettes: MouilletteScores;
  durationS?: number;
}

export interface PostConsultationResponse {
  ok: true;
  id: string;
  couponCode: string;
  discount: number;
  recommendations: Recommendation[];
}

export async function postConsultation(
  payload: PostConsultationPayload
): Promise<PostConsultationResponse> {
  const res = await fetch(`${BASE}/consultations`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`postConsultation ${res.status}: ${text}`);
  }
  return (await res.json()) as PostConsultationResponse;
}

export interface QrLandingResponse {
  ok: true;
  id: string;
  name?: string;
  recommendations: Array<{
    productId: string;
    matchPct: number;
    reasons: string[];
    title?: string;
    brand?: string;
    family?: string;
    price?: number;
    currency?: string;
    imageUrl?: string;
    productUrl?: string;
    description?: string;
    notes: { top: string[]; heart: string[]; base: string[] };
  }>;
  coupon: { code: string; discount: number; redeemed: boolean; expiresAt: string } | null;
  store: { id: string; name: string; city: string; address?: string; schedule?: string } | null;
}

export async function getLanding(id: string): Promise<QrLandingResponse> {
  const res = await fetch(`${BASE}/r/${encodeURIComponent(id)}`);
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`getLanding ${res.status}: ${text}`);
  }
  return (await res.json()) as QrLandingResponse;
}
